import axios from "@/libs/api.request";
// 获取小包绩效列表
export const getAirPerformance = (params) => {
  return axios.request({
    url: "/report/achievements/airdepartment",
    method: "get",
    params,
  });
};
